import React from 'react';

class PageCss extends React.Component {

    static get defaultProps() {
        return {
            css: {}
        }
    }

    render() {
        return (
                <style type = "text/css">
                {
                   this._buildCssString()
                }
                </style>
        )
    }

    _buildCssString() {

        const { css  } = this.props;
        const cssPrefix = '.configurator-main';
        const cssPrefixReplacement = ', ' + cssPrefix + ' ';
        let cssString = '';

        // loop object
        Object.keys(css).map(function(key) {
            cssString = cssString + cssPrefix + ' ' + key.replace(/,/g, cssPrefixReplacement) + ' {';
            Object.keys(css[key]).map(function(key2) {
                cssString = cssString  + key2 + ': ' + css[key][key2] + '; ';
            });
            cssString = cssString + '}' + "\n";
        });

        return cssString;
    }
}

export default PageCss;


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/PageCss.react.jsx